import { render, staticRenderFns } from "./CreditsList.vue?vue&type=template&id=0e12f11e&scoped=true&"
import script from "./CreditsList.vue?vue&type=script&lang=js&"
export * from "./CreditsList.vue?vue&type=script&lang=js&"
import style0 from "./CreditsList.vue?vue&type=style&index=0&id=0e12f11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e12f11e",
  null
  
)

export default component.exports